import loadable from '../utils/loadable';

const Introduction = loadable(() => import('../components/PrivacyComponent/Articles/Introduction'));
const Definitions = loadable(() => import('../components/PrivacyComponent/Articles/Definitions'));
const DataWeCollect = loadable(() => import('../components/PrivacyComponent/Articles/DataWeCollect'));
const DataToProvide = loadable(() => import('../components/PrivacyComponent/Articles/DataToProvide'));
const DataToShare = loadable(() => import('../components/PrivacyComponent/Articles/DataToShare'));
const DataSecure = loadable(() => import('../components/PrivacyComponent/Articles/DataSecure'));
const ManageData = loadable(() => import('../components/PrivacyComponent/Articles/ManageData'));
const CookiesAndWebBeacons = loadable(() => import('../components/PrivacyComponent/Articles/CookiesAndWebBeacons'));
const Subscription = loadable(() => import('../components/PrivacyComponent/Articles/Subscription'));
const NewsletterTracking = loadable(() => import('../components/PrivacyComponent/Articles/NewsletterTracking'));
const Contact = loadable(() => import('../components/PrivacyComponent/Articles/Contact'));
const Blog = loadable(() => import('../components/PrivacyComponent/Articles/Blog'));
const RoutineErasure = loadable(() => import('../components/PrivacyComponent/Articles/RoutineErasure'));
const RightsOfTheDataSubject = loadable(() => import('../components/PrivacyComponent/Articles/RightsOfTheDataSubject'));
const LegalBasis = loadable(() => import('../components/PrivacyComponent/Articles/LegalBasis'));
const LegitimateInterests = loadable(() => import('../components/PrivacyComponent/Articles/LegitimateInterests'));
const PeriodTheDataWillBeStored = loadable(() => import('../components/PrivacyComponent/Articles/PeriodTheDataWillBeStored'));
const Changes = loadable(() => import('../components/PrivacyComponent/Articles/Changes'));

export const ARTICLES = {
  Introduction: {
    title: 'Introduction',
    component: Introduction,
  },
  Definitions: {
    title: 'Definitions',
    component: Definitions,
  },
  DataWeCollect: {
    title: 'Data we collect',
    component: DataWeCollect,
  },
  DataToProvide: {
    title: 'What data do we ask you to provide to us and why?',
    component: DataToProvide,
  },
  DataToShare: {
    title: 'What personal data do we share?',
    component: DataToShare,
  },
  DataSecure: {
    title: 'How do we keep your personal data secure?',
    component: DataSecure,
  },
  ManageData: {
    title: 'How you can access and manage this data?',
    component: ManageData,
  },
  CookiesAndWebBeacons: {
    title: 'Cookies and Web Beacons',
    component: CookiesAndWebBeacons,
  },
  Subscription: {
    title: 'Subscription to our newsletters and alerts',
    component: Subscription,
  },
  NewsletterTracking: {
    title: 'Newsletter-Tracking',
    component: NewsletterTracking,
  },
  Contact: {
    title: 'Contact via the website',
    component: Contact,
  },
  Blog: {
    title: 'Blog subscription and comments',
    component: Blog,
  },
  RoutineErasure: {
    title: 'Routine erasure and blocking of personal data',
    component: RoutineErasure,
  },
  RightsOfTheDataSubject: {
    title: 'Rights of the data subject',
    component: RightsOfTheDataSubject,
  },
  LegalBasis: {
    title: 'Legal basis for the processing',
    component: LegalBasis,
  },
  LegitimateInterests: {
    title: 'The legitimate interests pursued by the controller or by a third party',
    component: LegitimateInterests,
  },
  PeriodTheDataWillBeStored: {
    title: 'Period for which the personal data will be stored',
    component: PeriodTheDataWillBeStored,
  },
  Changes: {
    title: 'Changes to our policy',
    component: Changes,
  },
};

export default ARTICLES;
